<script>

import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import config from "../../config";
import pagination from "laravel-vue-pagination";
import { supplierService } from "../../services";
import SupplierDetails from "./supplier-details";
import { base64,debounce,success_message,error_message } from "../../Helper/helper";

export default {
  components: { Layout, PageHeader, pagination,SupplierDetails},
    data() {
        const { status,orderBy,sortBy} = this.$route.query;
        return {
            title: this.trans.get('__JSON__.Supplier'),
            url: null,
            debounce: false,
            items: [],
            checked: true,
            sortBy: sortBy || "id",
            sortDesc: orderBy && orderBy != '' ? true : orderBy,
            loading: true,
            paginations: {},
            limit: 1,
            search: "",
            status: status == undefined ? '1' :status,
            config: config,
            brandCount: "",
            showModal: false,
            supplierData: [],
            searchData:debounce(()=>{
                if(!this.init){
                    const {status,orderBy,sortBy} = this.$data;
                    this.$router.replace({name: 'supplier-list', query: {status,orderBy,sortBy}})
                }
                this.getSupllier();
                this.init = false;
            },500),
            
            fields: [
                { key: "id", label: "#", sortable: true },
                { key: "producer_company_id", label: "Supplier Name", sortable: true },
                { key: "customer_id", label: "Our Customer ID", sortable: true },
                { key: "phone_number", label: "Phone Number", sortable: true },
                { key: "email", label: "Email Address", sortable: true },
                { key: "order_until", label: "Order until", sortable: true },
                { key: "delivery_date", label: "Delivery date", sortable: true },
                { key: "order_from", label: "Order from", sortable: true },
                { key: "status", label: "Status", sortable: false,thClass:"dis-event" },
                { key: "action", label: "Action", sortable: false,thClass:"dis-event" },
            ],
        };
    },
    mounted() {
        this.getSupllier();
    },
    methods: {
        onRowClicked(item) {
            supplierService
            .getSupplierById({ id: this.base64(item.id) }).then((response) => {
                this.showModal = true;
                this.supplierData = response.data.result;
               
            });
        },
        sortingChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getSupllier();
        },
        getSupllier(page) {
            this.loading = true;
            supplierService
            .getSupplierList({ 
                search: this.search,
                status: this.status,
                sortBy: this.sortBy,
                orderBy: this.sortDesc ? "desc" : "asc",
                page: page && page > 0 ? page : 1,
            })
            .then((response) => {
                this.loading = false;
                this.paginations = response.data.result;
                this.items = response.data.result.data;
            });
        },
        deleteSupplier(id){
            if(confirm("Do you really want to delete?")){
                supplierService.deleteSupplier({id:id})
                .then(response => {
                    if (response.data.code === 200) {
                         this.getSupllier();
                        success_message(response.data.message);
                    } else {
                        error_message(response.data.message);
                    }
                });
            }
        },
        salesManModal(id){
            this.showModal = true;
        },
        showSupplierDetails(id){
            supplierService
            .getSupplierById({ id: id }).then((response) => {
                this.supplierData = response.data.result;
                this.showModal = true;
            });
        },
        navigateToSupplierEdit(id) {
            this.$router.push({ name: 'supplier-edit', params: { id: (id) } });
        },
        handleModalHidden() {
            this.showModal = false;
            this.getSupllier(); // Refresh the supplier list when the modal is hidden
        },
    },
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page" >
                    <div class="page-title-left">
                        <div class="avatar-xs mr-3">
                        <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                            <i class="bx bx-user-circle"></i>
                        </span>
                        </div>
                        <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Supplier') }}</h4>
                    </div>
                    <div class="page-title-right d-flex">
                        <router-link :to="{name: 'supplier-add'}" class="btn btn-success btn-rounded mr-2 add-btn">
                            <i class="mdi mdi-plus mr-1"></i>
                            {{ trans.get('__JSON__.Add Supplier') }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row list-table-main">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2 offset-sm-8">
                                <div class="form-group">
                                    <div class="date-range-list">
                                        <label>{{ trans.get('__JSON__.Status') }} :</label>
                                        <select class="custom-select" v-model="status" @change="searchData()">
                                        <option value="">{{ trans.get('__JSON__.All') }}</option>
                                        <option value="1" selected>{{ trans.get('__JSON__.Active') }}</option>
                                        <option value="0">{{ trans.get('__JSON__.Inactive') }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="date-range-list">
                                    <label>{{ trans.get('__JSON__.Search') }} :</label>
                                    <div class="text-sm-right">
                                        <div class="search-box mr-2 d-inline-block">
                                            <div class="position-relative">
                                                <input
                                                type="text"
                                                class="form-control"
                                                id="search"
                                                @input="searchData()"
                                                v-model="search"
                                                :placeholder="trans.get('__JSON__.Search Placeholder')"
                                                />
                                                <i class="bx bx-search-alt search-icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 table-main-list customer-table table-responsive">
                                <b-table
                                :items="items"
                                :fields="fields"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :no-local-sorting="true"
                                @sort-changed="sortingChanged"
                                :busy="loading"
                                show-empty
                                @row-clicked="onRowClicked"
                                >
                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>{{trans.get('__JSON__.Loading...')}}</strong>
                                    </div>
                                </template>
                                <template v-slot:cell(id)="data">
                                    <span>{{ data.item.id }}</span>
                                </template>

                                <template v-slot:cell(producer_company_id)="data">
                                    <span>{{ data.item.producer_company_name }}</span>
                                </template>
                                <template v-slot:cell(customer_id)="data">
                                    <span>{{data.item.customer_id }}</span>
                                </template>
                                <template v-slot:cell(phone_number)="data">
                                    <span>{{ data.item.phone_number }}</span>
                                </template>
                                <template v-slot:cell(email)="data">
                                    <span>{{ data.item.email }}</span>
                                </template>
                                <template v-slot:cell(order_until)="data">
                                    <span>{{ data.item.order_until }}</span>
                                </template>
                                <template v-slot:cell(delivery_date)="data">
                                    <span>{{ data.item.delivery_date }}</span>
                                </template>
                                <template v-slot:cell(order_from)="data">
                                    <span>{{ data.item.order_from }}</span>
                                </template>

                                <template v-slot:cell(status)="data">
                                    <div
                                    v-if="data.item.status == '0'"
                                    class="badge badge-pill badge-soft-danger font-size-12"
                                    >{{ trans.get('__JSON__.Inactive') }}</div>
                                    <div
                                    v-if="data.item.status == '1'"
                                    class="badge badge-pill badge-soft-success font-size-12"
                                    >{{ trans.get('__JSON__.Active') }}</div>
                                </template>

                                <template v-slot:cell(action)="data">
                                    <div>
                                        <b-dropdown lazy id="dropdown-1" variant="link" right role="navigation" class="m-md-2" v-if="$auth.hasPermission(config.permissions.order_write)">
                                            <template #button-content>
                                                <i class="bx bx-dots-vertical-rounded"></i>
                                            </template>
                                            <b-dropdown-item @click="navigateToSupplierEdit(base64(data.item.id))">
                                                {{ trans.get('__JSON__.Edit') }}
                                            </b-dropdown-item>
                                            <!-- <b-dropdown-item>
                                                <span>
                                                    <router-link
                                                        :to="{name: 'supplier-edit',params: { id:base64(data.item.id)}}"
                                                        >{{ trans.get('__JSON__.Edit') }}
                                                    </router-link>
                                                </span>
                                            </b-dropdown-item> -->
                                            <b-dropdown-item  @click="showSupplierDetails(base64(data.item.id))" >{{ trans.get('__JSON__.Salesman') }}</b-dropdown-item>
                                            <b-dropdown-item  @click="deleteSupplier(base64(data.item.id))">{{ trans.get('__JSON__.Delete') }}</b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                </template>

                                <template #empty>
                                    <p class="text-center">{{ trans.get('__JSON__.No Supplier') }}</p>
                                </template>
                                </b-table>
                            </div>
                            <div class="row col-sm-5 offset-sm-7">
                                <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                    <!-- pagination -->
                                        <pagination
                                            :data="paginations"
                                            :limit="limit"
                                            @pagination-change-page="getSupllier"
                                        ></pagination>
                                    </ul>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <SupplierDetails
            v-if="showModal"
            :supplierdata="supplierData"
            @actionChanged="$emit('refreshData')"
             @hidden="handleModalHidden"
            />
    </div>
</template>